import { render, staticRenderFns } from "./AlertWithButtonModal.vue?vue&type=template&id=a3a31d68&scoped=true"
import script from "./AlertWithButtonModal.vue?vue&type=script&lang=js"
export * from "./AlertWithButtonModal.vue?vue&type=script&lang=js"
import style0 from "./AlertWithButtonModal.vue?vue&type=style&index=0&id=a3a31d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a31d68",
  null
  
)

export default component.exports